module.exports = __webpack_public_path__ + "static/img/3_1_5_1.43f28afa.jpg";